import enMessages from './locales/en.json';
import ukMessages from './locales/uk.json';

export type Locale = 'en' | 'uk';
export const DEFAULT_LOCALE = 'en' as Locale;

const LOCALE_STORAGE_KEY = 'app-locale';

// @ts-expect-error - fix later
type NestedMessages = Record<string, string | NestedMessages>;

function flattenMessages(nestedMessages: NestedMessages, prefix = ''): Record<string, string> {
  return Object.keys(nestedMessages).reduce((messages: Record<string, string>, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
}

export const messages: Record<Locale, Record<string, string>> = {
  en: flattenMessages(enMessages as NestedMessages),
  uk: flattenMessages(ukMessages as NestedMessages),
};

export function getStoredLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  return stored === 'en' || stored === 'uk' ? stored : DEFAULT_LOCALE;
}

export function setStoredLocale(locale: Locale): void {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}
